export interface IDebounceController {
  run(callback: () => void): void;
  cancel(): void;
}

export function createDebounce(timeoutMs: number): IDebounceController {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  return {
    run(callback: () => void) {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        timeoutId = null;
        callback();
      }, timeoutMs);
    },
    cancel() {
      if (timeoutId) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
    },
  };
}
